$(document).ready(function () {
    const REACT_MOBILE_MENU_OPEN_CLASS = 'react-mobile-menu-open';
    const LEGACY_MENU_HIDE_DELAY_MS = 400;
    const REACT_MENU_HIDE_DELAY_MS = 300;

    const hasReactStyledMobileMenu = () => {
        return $('#dl-menu .mobile-menu-brand-logo-item').length > 0;
    };

    const getMenuHideDelay = () => {
        return hasReactStyledMobileMenu() ? REACT_MENU_HIDE_DELAY_MS : LEGACY_MENU_HIDE_DELAY_MS;
    };

    const setReactMenuOpenState = (isOpen) => {
        if (!hasReactStyledMobileMenu()) {
            return;
        }

        $('#dl-menu').toggleClass(REACT_MOBILE_MENU_OPEN_CLASS, isOpen);
    };

    const toggleSlideoutTargets = (shouldSlideOut) => {
        if (hasReactStyledMobileMenu()) {
            return;
        }

        const method = shouldSlideOut ? 'addClass' : 'removeClass';

        $('#topnav')[method]('dl-custom-slideout');
        $('.hero-container')[method]('dl-custom-slideout');
        $('.hero-jobs-container')[method]('dl-custom-slideout');
        $('main')[method]('dl-custom-slideout');
        $('#responsive_content')[method]('dl-custom-slideout'); // Blog
        $('.footer')[method]('dl-custom-slideout');
    };

    const closeMenu = () => {
        const $toggler = $('.toggler i');
        const $dlMenu = $('#dl-menu');
        $dlMenu.dlmenu('closeMenu');
        $toggler.removeClass('mdi-close');
        $toggler.addClass('mdi-menu');

        // The timeout should be the same as the CSS transition duration.
        setReactMenuOpenState(false);
        setTimeout(() => $dlMenu.hide(), getMenuHideDelay());
        $('body').removeClass('remove_scroll');
        toggleSlideoutTargets(false);

        $(document).off('click.mobile-menu');
    };

    const onClickOutsideMenu = (event) => {
        // Don't manually close if the click originated from the actual menu
        // or the menu toggler.
        if ($(event.target).closest('.dl-menu,.toggler').length === 0) {
            $('.toggler').removeClass('open');
            closeMenu();
        }
    };

    const openMenu = () => {
        const $toggler = $('.toggler i');
        $toggler.removeClass('mdi-menu');
        $toggler.addClass('mdi-close');
        $('#dl-menu').show().dlmenu('openMenu');
        requestAnimationFrame(() => setReactMenuOpenState(true));
        $('body').addClass('remove_scroll');
        toggleSlideoutTargets(true);

        // Close the menu if the user clicks outside of it.
        $(document).on('click.mobile-menu', onClickOutsideMenu);
    };

    let mobileMenuInitialized = false;

    const initMobileMenu = () => {
        $('#dl-menu').hide().dlmenu({
            animationClasses: {
                classin: 'dl-animate-in-2',
                classout: 'dl-animate-out-2',
            },
        });

        if (/iPhone|iPad/.test(navigator.userAgent)) {
            $('*').css('cursor', 'pointer');
        }

        mobileMenuInitialized = true;
    };

    const enableMobileMenu = () => {
        if (!mobileMenuInitialized) {
            initMobileMenu();
        }

        $('.custom-nav-hide').hide();
    };

    const disableMobileMenu = () => {
        if (mobileMenuInitialized) {
            $('.toggler').removeClass('open');
            closeMenu();
        }

        $('.mobile_menu_hide').hide();
        $('.custom-nav-hide').show();
    };

    const checkNeedsMobileMenu = () => {
        if ($(window).width() <= 991) {
            enableMobileMenu();
        } else {
            disableMobileMenu();
        }
    };

    checkNeedsMobileMenu();

    $(window).on('resize', checkNeedsMobileMenu);

    $(document).on('click', '.toggler', function () {
        if ($('.toggler').hasClass('open')) {
            openMenu();
        } else {
            closeMenu();
        }
    });

    $('.hasSubmenu > a').click(function () {
        const prevText = $(this).find('span').text();
        $(this).parent().find('.dl-submenu:first > .dl-back:first > a:first')
            .html('<i class="mdi mdi-cheveron-left dl-custom-nav md"></i>'+prevText);
    });

    $('.dl-toggle-container').on('click', function () {
        const $toggle = $(this).find('.dl-toggle');

        if ($toggle.hasClass('on')) {
            $toggle.siblings('input').prop('checked', false);
            $toggle.removeClass('on');
        } else {
            $toggle.siblings('input').prop('checked', true);
            $toggle.addClass('on');
        }
    });
});
